import { render, staticRenderFns } from "./SwitchBetweenColumnsButton.vue?vue&type=template&id=07644299&scoped=true&"
import script from "./SwitchBetweenColumnsButton.vue?vue&type=script&lang=js&"
export * from "./SwitchBetweenColumnsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07644299",
  null
  
)

export default component.exports